export default "__VITE_ASSET__QueC51SX__"